import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Image, Skeleton } from 'antd';
import { BASE_URL } from '../constants/Url';
import { useNavigate } from 'react-router';
import { eventsData } from '../constants/TempData';
import { showFormatDate } from '../utils/Utils';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { Meta } = Card;

const Events = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true); // 👈 loading true first
    const [events, setEvent] = useState([
        {
            title: "",
            date: "",
            description: "",
            image: "",
            code: "",
        }
    ]);

    useEffect(() => {
        fetchBlog();
    }, [])

    const fetchBlog = async () => {
        const res = eventsData;

        setEvent([...res])
    }
    const handleViewDetail = (item) => {
        navigate(`/events/${item.code}`, { state: { events: item } });
    }

    // ⏳ setTimeout 1 minute (1000ms) to switch loading -> data
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // 🔥 stop loading after 1min
        }, 2000);

        return () => clearTimeout(timer); // Cleanup if unmount
    }, []);

    return (
        <div className='esi-std-container pt-5 pb-6' style={{ backgroundColor: 'white', paddingTop: "60px" }}>
            {/* Section Title */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <div className="esi-content-title">
                    {t("Events")}
                    <div className="esi-secondary-line"></div>
                </div>
                <Link to="/events" style={{ color: '#119811', fontWeight: 'bold', textDecoration: 'none' }}>
                    {t("View All Events")} →
                </Link>
            </div>

            {/* Teacher Cards */}
            <Row gutter={[24, 24]} className='mt-6'>
                {loading ? (
                    <>
                        {Array(3).fill(0).map((_, index) => (
                            <Col key={index} xs={24} sm={12} md={8}>
                                <div key={index} className='cursor-pointer select-none esi-news-card'>
                                    <div className='overflow-hidden max-sm:rounded-[1rem]'>
                                        <Skeleton.Image rootClassName='esi-news-card-image' className='esi-news-card-image' active={true} />
                                    </div>
                                    <div className='text-start w-50 text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[50%] mt-3 line-clamp-2'>
                                        <Skeleton.Input active block />
                                    </div>
                                    <div className='text-start w-full text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[100%] mt-3 line-clamp-2'>
                                        <Skeleton.Input active block />
                                        <Skeleton.Input active block />
                                    </div>
                                    <div className='text-start w-50 text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[50%] mt-3 line-clamp-2 d-flex m-auto'>
                                        <Skeleton.Input active block />
                                    </div>
                                </div>

                            </Col>
                        ))}
                        <div className='text-start w-50 text-white md:text-black absolute left-[24px] bottom-[6px] md:relative md:left-0 md:bottom-0 esi-news-card-title max-w-[calc(100%-24px*2)] md:max-w-[50%] mt-3 line-clamp-2 d-flex m-auto'>
                            <Skeleton.Input active block style={{ height: "50px", backgroundColor:"rgba(17, 152, 17, 0.2)" }} />
                        </div>
                    </>
                ) :
                    (
                        <>
                            {
                                events.map((event, index) => (
                                    <Col key={index} xs={24} sm={12} md={8}>
                                        <Card
                                            hoverable
                                            cover={<img alt={event.title} src={BASE_URL + event.image} style={{ height: '200px', objectFit: 'cover' }} />}
                                        >
                                            <Meta
                                                title={<h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1d1d1d' }}>{event.title}</h3>}
                                                description={
                                                    <>
                                                        <p style={{ margin: '8px 0', fontSize: '14px', color: '#888' }}>{showFormatDate(event.date)}</p>
                                                        <p className='esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3'>{event.description}</p>
                                                        <p onClick={() => handleViewDetail(event)} style={{ color: '#119811' }} className='pb-5 mt-3'>
                                                            {t("View Event")} →
                                                        </p>
                                                    </>
                                                }
                                            />
                                        </Card>
                                    </Col>
                                ))
                            }
                            {/* Call-to-Action Button */}
                            {/* <div className="text-center mt-10" style={{ margin: 'auto' }}>
                                <button
                                    className="px-6 py-3 text-white text-lg font-semibold rounded-lg shadow transition duration-300"
                                    style={{ backgroundColor: '#119811' }}
                                >
                                    {t("See More")}
                                </button>
                            </div> */}
                        </>
                    )}
            </Row>
        </div>
    );
};

export default Events;
